// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i7wo3","version-label":"styles_version-label__x+Osv","actions-wrapper":"styles_actions-wrapper__eqnNO","disabled-block":"styles_disabled-block__rivsG"};